import { Pipe, PipeTransform } from '@angular/core';
import { ActorObject } from '../../shared/datamodel';

import { LssEntity } from '../../configuration/store/lss-entity.datamodel';

/**
 * Pipe to determine if a given entity is a parent of the selected entity.
 */
@Pipe({
    name: 'isParentOfSelectedEntity',
    standalone: false
})
export class IsParentOfSelectedEntityPipe implements PipeTransform {

  transform<E extends LssEntity<E>>(entity: E, selectedActor: ActorObject | undefined ): boolean {
    if (!selectedActor) {
      return false;
    }
    return entity.childrenTree ? entity.childrenTree.some((child: E) =>
      this.isSelected(child, selectedActor)) : false;
  }

  /**
   * Check if the entity or any of his children is selected
   * @param entity LSS Entity
   * @param selectedActor Selected Actor
   * @private
   */
  private isSelected<E extends LssEntity<E>>(entity: E, selectedActor: ActorObject): boolean {
    if (entity.actor === selectedActor) {
      return true;
    }
    return entity.childrenTree ? entity.childrenTree.some((child: E) =>
      this.isSelected(child, selectedActor)) : false;
  }
}
